import { SORT_ORDER } from 'constants.js'
import { selectRequestParams } from 'data/selectors'
import { getDateKey } from 'data/utils'
import { createSelector } from 'reselect'
import { emptyArray } from 'utils'

import { SORT_COLUMNS } from './constants'

export const sort = state => state.clubCardModal.sort

export const countriesClubShare = createSelector(
  selectRequestParams,
  state => state.channels,
  sort,
  // eslint-disable-next-line sonarjs/cognitive-complexity
  (requestParams, channelsData, { order, sortBy }) => {
    const dataKey = getDateKey({
      ...requestParams,
      channelsType: 'channels',
    })
    const countries = channelsData[dataKey]?.data || emptyArray

    if (!countries.length) {
      return countries
    }

    return [...countries]
      .sort((countryA, countryB) => {
        const columnA = countryA.revenueClubCurrent / countryA.revenueCurrent
        const columnB = countryB.revenueClubCurrent / countryB.revenueCurrent

        if (columnA < columnB) {
          return 1
        }

        if (columnA > columnB) {
          return -1
        }

        return 0
      })
      .map((country, index) => ({
        ...country,
        no: index + 1,
        shareClubCard: country.revenueClubCurrent / country.revenueCurrent || 0,
      }))
      .filter(({ shareClubCard }) => shareClubCard)
      .sort((countryA, countryB) => {
        const isOrderDesc = order === SORT_ORDER.DESC
        const columnA = isOrderDesc ? countryA[sortBy] : countryB[sortBy]
        const columnB = isOrderDesc ? countryB[sortBy] : countryA[sortBy]

        if (sortBy === SORT_COLUMNS.COMPANY) {
          const countryNameLocaleA = countryA.channel
          const countryNameLocaleB = countryB.channel
          const upperColumnA = isOrderDesc ? countryNameLocaleA.toUpperCase() : countryNameLocaleB.toUpperCase()
          const upperColumnB = isOrderDesc ? countryNameLocaleB.toUpperCase() : countryNameLocaleA.toUpperCase()

          if (upperColumnA < upperColumnB) {
            return 1
          }

          if (upperColumnA > upperColumnB) {
            return -1
          }
        } else {
          if (columnA < columnB) {
            return 1
          }

          if (columnA > columnB) {
            return -1
          }
        }

        return 0
      })
  },
)
